import { Switch } from 'antd';
import CreateAntField from './CreateAntField';

export default CreateAntField(Switch);
